import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step7 } from '../../../../shared/models/component-messages/mapaIN/step7';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_65 } from '../../../validators/65/ctrl65';
import { CTRL_69 } from '../../../validators/69/ctrl69';
import { Conditions } from '../models/Conditions';
import { MapaINControlNames } from '../service/mapaINControleNames';
@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html'
})
export class ConditionsComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Conditions';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() conditions: Conditions;

  public step7 = new Step7();

  public rg1 = CTRL_65.id + '_1';
  public rg2 = CTRL_69.id + '_1';
  public rg3 = CTRL_65.id + '_3';

  radioButtonValue;
  radioButtonCtrlName;
  oui = RadioCheckBoxEnum.ouiValue;
  non = RadioCheckBoxEnum.nonValue;

  constructor() { }

  public ngOnInit() {
    this.radioButtonCtrlName = this.getUid() + '_SepAtt_autresConditionsOui';
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_67Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_69Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_71Names_json() }));

  }


  langue(){
		return this.parentForm.controls[this.getUid() + '_SepAtt_langueFR']?.value;
  }





  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
}

